var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalTabs4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 30,
    viewBox: "0 0 67 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.328125 0.699951H90.3281V8.69995H0.328125V0.699951Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46777 5.0271L5.41309 3.42456H6.42676L7.0625 4.46753L7.7041 3.42456H8.71777L7.65137 5.0271L8.76758 6.69995H7.75098L7.0625 5.57788L6.37109 6.69995H5.35742L6.46777 5.0271ZM9.93652 5.0271L8.88184 3.42456H9.89551L10.5312 4.46753L11.1729 3.42456H12.1865L11.1201 5.0271L12.2363 6.69995H11.2197L10.5312 5.57788L9.83984 6.69995H8.82617L9.93652 5.0271ZM13.4053 5.0271L12.3506 3.42456H13.3643L14 4.46753L14.6416 3.42456H15.6553L14.5889 5.0271L15.7051 6.69995H14.6885L14 5.57788L13.3086 6.69995H12.2949L13.4053 5.0271ZM16.874 5.0271L15.8193 3.42456H16.833L17.4688 4.46753L18.1104 3.42456H19.124L18.0576 5.0271L19.1738 6.69995H18.1572L17.4688 5.57788L16.7773 6.69995H15.7637L16.874 5.0271Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 13.2H89.8281V29.2H0.828125V13.2Z",
    stroke: "#7C7C7C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.32812,
    y: 2,
    width: 16,
    height: 5.5,
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3281,
    y: 2,
    width: 16,
    height: 6,
    fill: "#C4C4C4",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3281,
    y: 2,
    width: 16,
    height: 6,
    fill: "#C4C4C4",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTabs4A);
export default __webpack_public_path__ + "static/media/HorizontalTabs4A.90b660fc3dababa2607c2dd7dcedeaef.svg";
export { ForwardRef as ReactComponent };